import { useTranslation } from 'react-i18next';
import LocationIcon from '@mui/icons-material/LocationOn';
import { LocationData, LocationForm } from 'components/EventForms';
import { Box } from '@mui/material';
import { spacingSizeMap } from '@insights-ltd/design-library/themes';
import { SectionTitle } from '@insights-ltd/design-library/components';
import EditFormNavigation from './EditFormNavigation';
import { EditProps } from './types';

const EditLocation = ({
  eventForm,
  onCancel,
  saveEvent,
  saving,
}: EditProps) => {
  const { t } = useTranslation();

  const onSubmit = (formData: LocationData) => {
    saveEvent(formData);
  };

  return (
    <>
      <Box
        sx={{
          mt: spacingSizeMap.L,
          mb: spacingSizeMap.L,
        }}
      >
        <SectionTitle
          icon={{ icon: <LocationIcon />, iconColour: 'pink' }}
          text={t('ui.event-management.events.create.location')}
        />
      </Box>
      <LocationForm event={eventForm} onSubmit={onSubmit}>
        <EditFormNavigation onCancel={onCancel} saving={saving} />
      </LocationForm>
    </>
  );
};

export default EditLocation;
